import { Number } from 'core-js'
import { simplify, size } from 'mathjs'
var Algebrite = require('algebrite')


//Constants
export const VALID_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png","gif"]
export const VALID_PDF_EXTENSIONS = ["pdf"]
export const VALID_VIDEO_EXTENSIONS = ["mp4"]
export const RESTRICTED_FILE_CHARS = ['*', '.', '"', '/', '\\', '[', ']', ':', ';', '|', ',']
export const WEBSITE_URL  = "http://167.86.98.171:8000/#"

export const CLICKABLE_QUESTION_PARAMETER  = +1
export const KEYBOARD_QUESTION_PARAMETER  = +2
export const MULTIPLE_CHOICE_QUESTION_PARAMETER  = +3
export const ENERGY_BALANCE_QUESTION_PARAMETER  = +4

export const trim_string = {textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}

export const STUDENT_USERNAME  ="STUDENT"

export const NORTH = 0
export const SOUTH = 2
export const EAST = 4
export const WEST = 8
export const CENTER = 16

export const INGOING_FLOW = 0
export const OUTGOING_FLOW = 2
export const SOURCE_FLOW = 4
export const UNSTEADY_FLOW = 8
//Functions
export function CreateChuck(A, N){
    let _A = []

    var i,j,  chunk = N;
    
    for (i=0,j= A.length; i<j; i+=chunk) {
        _A.push(A.slice(i,i+chunk));
    }

    return _A
}

export function UpdateDatapool(dp){
    localStorage.setItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG', dp.Id) 
    localStorage.setItem('USER_DATA_POOL_NAME_HEAT_QUIZ_APP_1567CDFG', dp.Name) 

}

export function GetFileExtension(filename){
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2)
}

export function CheckOwnership(o, Name){
    if(Name.toUpperCase() == "student".toUpperCase())
    {
        return false
    }

    return true

    //return o.Owners.map((o) => o.Name).includes(Name)
}

export function verifyKeyboardAnswer(answer, isEnergyBalance){
        
    if(!answer.List.length){
        return  [false,"Answer cannot be empty"]
    }

    if(answer.echoNumber){
        return [false,"Please close brackts, " + answer.echoNumber + " left to close"]
    }

    if(['*','-','+','/', '='].includes(answer.List.slice(-1)[0].code)){
        return [false,"Last charachter cannot be an operand"]
    }

    if(isEnergyBalance){
        let AnswerReduced = answer.List.reduce((b,a) => b += a.char, '')


        let Equal_Count = 0
        for(let c of AnswerReduced){
            if(c == '='){
                Equal_Count = Equal_Count + 1
            }
        }

        if(Equal_Count != 1){
            return [false,"You should add one 'Equal =' operand"]
        }

    }

    return [true,""]
}

export function GetRepeatedAnswer(answer, otherAnswers){
    let answerReduced = answer.List.reduce((b,a) => b += a.char, '')

    for(let i = 0; i<otherAnswers.length; i++){
        let otherAnswerReduced = otherAnswers[i].List.reduce((b,a) => b += a.char, '')
        
        let same_answer = (SafeSimplify("(" + otherAnswerReduced + ")" +  "-" + "(" +answerReduced+ ")" )) == '0'
        
        if(same_answer){
            return i
        }
    }

    return undefined
}

export function checkRepeatedAnswers(answers){

    for(let i=0; i<answers.length-1; i++){

        let answer = answers[i]
        let answerReduced = answer.List.reduce((b,a) => b += a.char, '')

        let otherAnswers = answers.slice(i+1, answers.length+1)

        for(let i = 0; i<otherAnswers.length; i++){
            let otherAnswerReduced = otherAnswers[i].List.reduce((b,a) => b += a.char, '')
            console.log(answerReduced)
            console.log(otherAnswerReduced)
            let same_answer = (SafeSimplify("(" + otherAnswerReduced + ")" +  "-" + "(" +answerReduced+ ")" )) == '0'
            console.log(same_answer)
            console.log("******")

            if(same_answer){
                return true
            }
        }
    }

    return false
}

export function GetCharsForKeyboardQuestion(){
    let matrix_one =  [
        ...GetCharArray('a','z'),
        ...GetCharArray('A', 'Z')
    ]

    let matrix_final = []

    for(let c of matrix_one){
        for(let a of matrix_one){
            matrix_final.push(c + a)
        }
    }

    return matrix_one
}

function GetCharArray(charA, charZ){
    var a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
    for (; i <= j; ++i) {
        a.push(String.fromCharCode(i));
    }

    return a
}

export function GetAnswerCharArray(){
    var text = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    var text2 = 'AA BB CC DD EE FF GG HH II JJ KK LL MM NN OO PP QQ RR SS TT UU VV WW XX YY ZZ aa bb cc dd ee ff gg hh ii jj kk ll mm nn oo pp qq rr ss tt uu vv ww xx yy zz'

    return {
        Numeric:text.split(''),
        Variable:text2.split(' ')
    }
}

export function checkForDuplicates(array) {
    return new Set(array).size !== array.length
  }

export function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}


export function CheckKeyboardAnswer(a, IsEnergyBalance){
        
    
    if(!a.List.length){

            return false
        }

        if(a.echoNumber){

            return false
        }

        if(a.List.length && ['*','-','+','/', '=','('].includes(a.List.slice(-1)[0].code)){
            return false
        }

        if(IsEnergyBalance){
            let AnswerReduced = a.List.reduce((b,a) => b += a.char, '')


            let Equal_Count = 0
            for(let c of AnswerReduced){
                if(c == '='){
                    Equal_Count = Equal_Count + 1
                }
            }

            if(Equal_Count != 1){
                return false
            }

        }

        return true
    
} 

export function combineArrays( array_of_arrays ){

    // First, handle some degenerate cases...

    if( ! array_of_arrays ){
        // Or maybe we should toss an exception...?
        return [];
    }

    if( ! Array.isArray( array_of_arrays ) ){
        // Or maybe we should toss an exception...?
        return [];
    }

    if( array_of_arrays.length == 0 ){
        return [];
    }

    for( let i = 0 ; i < array_of_arrays.length; i++ ){
        if( ! Array.isArray(array_of_arrays[i]) || array_of_arrays[i].length == 0 ){
            // If any of the arrays in array_of_arrays are not arrays or zero-length, return an empty array...
            return [];
        }
    }

    // Done with degenerate cases...

    // Start "odometer" with a 0 for each array in array_of_arrays.
    let odometer = new Array( array_of_arrays.length );
    odometer.fill( 0 ); 

    let output = [];

    let newCombination = formCombination( odometer, array_of_arrays );

    output.push( newCombination );

    while ( odometer_increment( odometer, array_of_arrays ) ){
        newCombination = formCombination( odometer, array_of_arrays );
        output.push( newCombination );
    }

    return output;
}/* combineArrays() */

// Translate "odometer" to combinations from array_of_arrays
function formCombination( odometer, array_of_arrays ){
    // In Imperative Programmingese (i.e., English):
    // let s_output = "";
    // for( let i=0; i < odometer.length; i++ ){
    //    s_output += "" + array_of_arrays[i][odometer[i]]; 
    // }
    // return s_output;

    // In Functional Programmingese (Henny Youngman one-liner):
    return odometer.reduce(
      function(accumulator, odometer_value, odometer_index){
        //return "" + accumulator + array_of_arrays[odometer_index][odometer_value];
        return ([...accumulator, array_of_arrays[odometer_index][odometer_value]])

      },
      []
    );
}/* formCombination() */

function odometer_increment( odometer, array_of_arrays ){

    // Basically, work you way from the rightmost digit of the "odometer"...
    // if you're able to increment without cycling that digit back to zero,
    // you're all done, otherwise, cycle that digit to zero and go one digit to the
    // left, and begin again until you're able to increment a digit
    // without cycling it...simple, huh...?

    for( let i_odometer_digit = odometer.length-1; i_odometer_digit >=0; i_odometer_digit-- ){ 

        let maxee = array_of_arrays[i_odometer_digit].length - 1;         

        if( odometer[i_odometer_digit] + 1 <= maxee ){
            // increment, and you're done...
            odometer[i_odometer_digit]++;
            return true;
        }
        else{
            if( i_odometer_digit - 1 < 0 ){
                // No more digits left to increment, end of the line...
                return false;
            }
            else{
                // Can't increment this digit, cycle it to zero and continue
                // the loop to go over to the next digit...
                odometer[i_odometer_digit]=0;
                continue;
            }
        }
    }/* for( let odometer_digit = odometer.length-1; odometer_digit >=0; odometer_digit-- ) */

}/* odometer_increment() */

/*export function SafeSimplify(text){
    try {
        return simplify(text)
    } catch (error) {
        return ''
    }
}*/

export function SafeSimplify(text){
    try {
        return Algebrite.run(text)
    } catch (error) {
        return ''
    }
}


export function ReduceNiceView(List){
    let Simplified = SafeSimplify(List.map(l => l.char).reduce((r, a) => r += a, '')).toString()

    for(let l of List){
        //Simplified = Simplified.replace(l.IsInteger ? l.code : l.char, l.code)
    }

    return Simplified

}


export function CalculateChoices(ValidValues){
    let Values = []

    if(ValidValues.length == 1 ){
        Values = GetUniqueValues(ValidValues[0])

    }

    if(ValidValues.length == 2)
    {

        let a1 = GetUniqueValues(ValidValues[0])
        let a2 = GetUniqueValues(ValidValues[1])

        for(var i = 0; i < a1.length; i++)
        {
             for(var j = 0; j <  a2.length; j++)
             {
                
                Values.push([a1[i], a2[j]])
             }
        }
    }

    if(ValidValues.length == 3)
    {

        let a1 = GetUniqueValues(ValidValues[0])
        let a2 = GetUniqueValues(ValidValues[1])
        let a3 = GetUniqueValues(ValidValues[2])

        for(var i = 0; i < a1.length; i++)
        {
             for(var j = 0; j <  a2.length; j++)
             {
                
                for(var k = 0; k <  a3.length; k++)
                {
                    
                    Values.push([a1[i] , a2[j] , a3[k]])
                }
             }
        }
    }

    if(ValidValues.length == 4)
    {

        let a1 = GetUniqueValues(ValidValues[0])
        let a2 = GetUniqueValues(ValidValues[1])
        let a3 = GetUniqueValues(ValidValues[2])
        let a4 = GetUniqueValues(ValidValues[3])

        for(var i = 0; i < a1.length; i++)
        {
             for(var j = 0; j <  a2.length; j++)
             {
                
                for(var k = 0; k <  a3.length; k++)
                {
                    
                    for(var z = 0; z <  a4.length; z++)
                    {
                        
                        Values.push([a1[i] , a2[j] , a3[k] , a3[z]])
                    }
                }
             }
        }
    }

    return Values

    
}

export function GetUniqueValues(array){
    return array.filter( onlyUnique );
}

function onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
}

export function validURL(str) {
    return true
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }


  
export function CheckAnswers(){
        let CorrectAnswers = []
        let WrongAnswers = []
        let SEPERATION_OPERANDS = ['+', '-']
        
        let Seperated_Indeces = []
        let Seperated_Parts = []

        let StudentAnswerChars = this.state.AnswerLetters.reduce((p, c,i) => 
            {
                if(SEPERATION_OPERANDS.includes(c.KeySimpleForm)){
                    Seperated_Parts.push(
                        {
                        SimpleForm: this.state.AnswerLetters.map((c) => c.KeySimpleForm).slice(Seperated_Indeces.length ? Seperated_Indeces[Seperated_Indeces.length - 1] : 0, i)
                        .reduce((a,b) => a += b),
                        
                        Array: this.state.AnswerLetters.slice(Seperated_Indeces.length ? Seperated_Indeces[Seperated_Indeces.length - 1] : 0, i)
                    }
                    )
                    Seperated_Indeces.push(i)

                }

                return  p += c.KeySimpleForm
            }
        , '')

        Seperated_Parts.push(
            {
                SimpleForm: this.state.AnswerLetters.map((c) => c.KeySimpleForm).slice(Seperated_Indeces[Seperated_Indeces.length - 1] , this.state.AnswerLetters.length)
                .reduce((a,b) => a += b, ''),
                
                Array:this.state.AnswerLetters.slice(Seperated_Indeces[Seperated_Indeces.length - 1] , this.state.AnswerLetters.length + 1)
                
            }
            
        )

        console.log(Seperated_Parts)
        console.log(Seperated_Indeces)
        this.props.Question.Answers.map((answer, i) => {

            let CorrectParts = []
            let WrongParts = []

            let AnswerChars = answer.AnswerElements.reduce((p, c, i) => {
                return p += c.Value
            }, '')
            let Calculation = SafeSimplify('( ' + AnswerChars +  ' ) - ( ' + StudentAnswerChars + ' )').toString()
            
            

            if(Calculation == '0'){
                CorrectAnswers.push(answer)
            }
            else{


                for(let index = 0; index < Seperated_Parts.length; index++){
                    let part = Seperated_Parts[index]

                    let MicroCalculation = SafeSimplify('( ' + AnswerChars +  ' ) - ( '+ part.SimpleForm + ' )').toString()
                    
                    if(MicroCalculation.length > AnswerChars.length){
                        WrongParts.push(part.Array)
                        console.log(part)
                    }else{
                        CorrectParts.push(part.Array)

                    }
                }

                WrongAnswers.push({
                    Answer:answer,
                    CorrectParts:CorrectParts,
                    WrongParts:WrongParts
                })
            }

        })

        return ({
            CorrectAnswers: CorrectAnswers,
            WrongAnswers: WrongAnswers
        })
}

export function getRandom(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len)
       return arr;
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

export function getRandom_Advanced(Elements, Size) {
    //Group Elements into Groups
    let ElementCodes = Elements.map((e,i) => {
        let Code = ""

        if(e.ClickableQuestionId){
            Code = e.ClickableQuestion.Code
        }

        if(e.KeyboardQuestionId){
            Code = e.KeyboardQuestion.Code
        }

        if(e.MultipleChoiceQuestionId){
            Code = e.MultipleChoiceQuestion.Code
        }

        return ({
            Code: Code,
            Index: i,
            Id: e.Id
        })
    })

    let ElementGroups = []

    for(let E of ElementCodes){
        

        if(ElementGroups.reduce((a,b) => a = [...a, ...b],[]).map((x) => x.Code).includes((E.Code))){
            continue
        }

        let Group = []
        let OtherCodes = ElementCodes.map((c) => {
            if(((c.Code.length - CompareStrings(E.Code, c.Code))/c.Code.length)> 0.60){
                Group.push(c)
            }
        })

        ElementGroups.push(Group)

    }

    console.log("ElementGroups")
    console.log(ElementGroups)

    let Selected_Indices = []
    let SelectedIds = []

    if(ElementGroups.length <Size){
        for(let i = 0; i <(Math.floor(Size/ElementGroups.length)); i++){
            Selected_Indices = [...Selected_Indices, ...(ElementGroups.map((g, i) => i))]
        }

        for(let i = 0; i <Size-Selected_Indices.length; i++){
            Selected_Indices.push(i)
        }
    }

    if(ElementGroups.length ==Size){
        Selected_Indices = getRandom(ElementGroups.map((g, i) => i), Size)

    }

    if(ElementGroups.length > Size){
        Selected_Indices = getRandom(ElementGroups.map((g, i) => i), Size)
    }

   
    for(let Index of Selected_Indices){
        let E = getRandom(ElementGroups[Index].filter((x) => !SelectedIds.includes(x.Id)).map((a) => a.Id), 1)

        if(!E.length){
            E = getRandom(Elements.filter((x) => !SelectedIds.includes(x.Id)).map((a) => a.Id), 1)
        }
        
        SelectedIds.push(E[0])
    }

    console.log("Selected_Indices")
    console.log(Selected_Indices)

    console.log("SelectedIds")
    console.log(SelectedIds)

    return SelectedIds
}

const groupBy = (key,array)  =>
    array.reduce((objectsByKeyValue, obj) => {
      const value = obj[key];
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {});

export function getRandom_Pools(Elements, Size) {
    let SelectedIds = []

    //sort questions by pools 
    const elementsByPoolNumber = Elements.reduce((groups, item) => {
        const group = (groups[item.PoolNumber] || []);
        group.push(item);
        groups[item.PoolNumber] = group;
        return groups;
      }, {});
    
    //Query question pools
    let n_pools = Object.keys(elementsByPoolNumber).length
    let pool_keys = Object.keys(elementsByPoolNumber)

    for (let i = 0; i<Size; i++){
        let pool_index = (i%n_pools)
        let q_array = elementsByPoolNumber[pool_keys[pool_index]]

        //get a random question from that loop that was not selected
        let randomId = null
 
        while(!randomId || SelectedIds.includes(randomId)){
            randomId = q_array[Math.floor(Math.random()*q_array.length)]
        }

        SelectedIds.push(randomId.Id)
    }

    return SelectedIds
}

function CompareStrings(a, b){
if(a.length == 0) return b.length; 
if(b.length == 0) return a.length; 

var matrix = [];

// increment along the first column of each row
var i;
for(i = 0; i <= b.length; i++){
    matrix[i] = [i];
}

// increment each column in the first row
var j;
for(j = 0; j <= a.length; j++){
    matrix[0][j] = j;
}

// Fill in the rest of the matrix
for(i = 1; i <= b.length; i++){
    for(j = 1; j <= a.length; j++){
    if(b.charAt(i-1) == a.charAt(j-1)){
        matrix[i][j] = matrix[i-1][j-1];
    } else {
        matrix[i][j] = Math.min(matrix[i-1][j-1] + 1, // substitution
                                Math.min(matrix[i][j-1] + 1, // insertion
                                        matrix[i-1][j] + 1)); // deletion
    }
    }
}

return matrix[b.length][a.length];

}

function GetNumberOfPages(numberOfQuestions, QuestionsPerPage){
    let N = Math.floor(numberOfQuestions/QuestionsPerPage) + Math.ceil((numberOfQuestions%QuestionsPerPage)/QuestionsPerPage)

    return N
}

export function intToString_Nice (value) {
    var suffixes = ["", "k", "m", "b","t"];
    var suffixNum = Math.floor((""+value).length/3);
    var shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000,suffixNum)) : value).toPrecision(2));
    if (shortValue % 1 != 0) {
        shortValue = shortValue.toFixed(1);
    }
    return shortValue+suffixes[suffixNum];
}


export function GetPagesArray(numberOfQuestions, QuestionsPerPage,QCodes){
    let N = GetNumberOfPages(numberOfQuestions, QuestionsPerPage)
    let A = []

    for(let i =0; i<N; i++){
        let Length1 = (i) * QuestionsPerPage
        let Length2 = (i+1) * QuestionsPerPage

        let Char1 = ""
        let Char2 = ""

        let total = 0
        for(let qc of QCodes){
            total += qc.Number

            if(Length1 <= total){
                Char1 = qc.Code 
                break
            }
        }

        total = 0

        for(let qc of QCodes){
            total += qc.Number

            if(i == N-1){
                Char2 = QCodes[QCodes.length - 1].Code

                break
            }

            if((total - qc.Number)<=Length2 && Length2 <= total){
                Char2 = qc.Code 
                break
            }
        }


        A.push({
            Index:i+1,
            Character: " (" + Char1 + "-" + Char2 + ")"
        })// +  )
    }

    return A
}

export function UpdatePlayerKey(newKey){
    localStorage.setItem('student_key_ABCDEFG', newKey) 
    window.location.reload(false);
}


export function FixURL(url)
{
    return url.replaceAll("\\", '/')
}

export function ValidatePoint(p){
    if(p.X < p.CX || p.X > Math.abs(p.CX + p.CWidth)){

        return false
    }

    if(p.Y < p.CY || p.Y > Math.abs(p.CY + p.CHeight)){

        return false
    }

    return true
}

export function ParseDate(myCSharpString){
    var date = new Date(Date.parse(myCSharpString));
    
    let day = date.getDate()<10 ? "0"+ date.getDate() : date.getDate()
    let month = date.getMonth()+1
     month = month<10 ? "0"+ month : month

    let hour = date.getHours()<10 ? "0"+ date.getHours() : date.getHours()
    let minutes = date.getMinutes()<10 ? "0"+ date.getMinutes() : date.getMinutes()


    return (day + "." + month + "." + date.getFullYear() + " " + hour+ ":" + minutes)
}
export function timeSince(_date) {
    let date = Date.parse(_date);
    var seconds = Math.floor((new Date() - date) / 1000);
  
    var interval = seconds / 31536000;
  
    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

export function CovertDate(JSDate){
    var date = JSDate;
    
    let day = date.getDate()<10 ? "0"+ date.getDate() : date.getDate()
    let month = date.getMonth()+1
     month = month<10 ? "0"+ month : month

    let hour = date.getHours()<10 ? "0"+ date.getHours() : date.getHours()
    let minutes = date.getMinutes()<10 ? "0"+ date.getMinutes() : date.getMinutes()


    return (day + "." + month + "." + date.getFullYear() + " " + hour+ ":" + minutes + ":00")
}

export function Download_File(data, filename, type) {
    var file = new Blob([data], {type: type});
    if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
        var a = document.createElement("a"),
                url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);  
        }, 0); 
    }
}

export function limitString(input_string, max_length){
    input_string = input_string.trim()
    return (input_string.length > (max_length-3) ? `${input_string.substring(0, (max_length-3))}...` : input_string)
}


//RESPONSIVE
let { innerWidth: Width, innerHeight: Height } = window;

window.addEventListener('orientationchange', UpdateWindowDimensions);

function UpdateWindowDimensions(){
    const { innerWidth: width, innerHeight: height } = window;
    Width = width
    Height = height
}

const percentageCalculation = (max, val) => max * (val / 100);

const fontCalculation = (height, width, val) => {
    const widthDimension = height > width ? width : height;
    const aspectRatioBasedHeight = (16 / 9) * widthDimension;
    return percentageCalculation(
      Math.sqrt(
        Math.pow(aspectRatioBasedHeight, 2) + Math.pow(widthDimension, 2)
      ),
      val
    );
  };

  export const responsiveHeight = (h) => {
    return percentageCalculation(Height, h);
  };
  
  export const responsiveWidth = (w) => {
        return percentageCalculation(Width, w);
  };
  
  export const responsiveFontSize = (f) => {
        return fontCalculation(Height, Width, f);
  };